import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarburst = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 33,
	fill: "none",
	viewBox: "0 0 32 33",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "pet__Star 1",
		fill: props.color,
		d: "M16 0.25L18.3985 2.89735L21.5579 1.23L22.9063 4.53803L26.4453 4.05178L26.581 7.62151L30.073 8.37501L28.9795 11.7759L32.0032 13.6782L29.8125 16.5L32.0032 19.3218L28.9795 21.2242L30.073 24.625L26.581 25.3785L26.4453 28.9483L22.9063 28.462L21.5579 31.7701L18.3985 30.1027L16 32.75L13.6015 30.1027L10.4422 31.7701L9.09376 28.462L5.55471 28.9483L5.41902 25.3785L1.92709 24.625L3.0205 21.2242L-0.00312614 19.3218L2.1875 16.5L-0.00312614 13.6782L3.0205 11.7759L1.92709 8.37501L5.41902 7.62151L5.55471 4.05178L9.09376 4.53803L10.4422 1.23L13.6015 2.89735L16 0.25Z"
	})
});
const ForwardRef = forwardRef(SvgStarburst);
export default ForwardRef;
